import { Layout } from '@community_dev/pixels'
import { Button, Card, Skeleton, Table, Typography } from 'antd'
import type { JSX } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import { CAPABILITIES } from 'constants/capabilities'
import { ROUTES } from 'constants/routes'
import { useHasCapability } from 'hooks/useCapabilities'
import { useSSOConfigsQuery } from 'hooks/useSSOConfigsQuery'
import { SidebarLayout } from 'shared/layouts'
import { route } from 'utils/router'

const StyledCard = styled(Card)`
  height: 100%;
`

export function SSOConfigsList(): JSX.Element {
  const history = useHistory()
  const { data, isInitialLoading } = useSSOConfigsQuery()
  const canManageSSOConfigs = useHasCapability(CAPABILITIES.ADMIN.SSO_CONFIGS.WRITE)

  const items = data?.data || []

  return (
    <SidebarLayout>
      <Layout height="100%" padding="12px">
        <StyledCard
          bordered
          extra={
            canManageSSOConfigs ? (
              <Button onClick={() => history.push(ROUTES.SSO_CONFIG_NEW)} type="primary">
                Create New
              </Button>
            ) : null
          }
          title={
            <Layout padding="12px 0">
              <Typography.Title level={4} style={{ margin: 0 }}>
                SSO Configs
              </Typography.Title>
              <Typography.Text type="secondary">List</Typography.Text>
            </Layout>
          }
        >
          {isInitialLoading ? (
            <Skeleton active paragraph={{ rows: 4 }} />
          ) : (
            <Table
              columns={[
                {
                  title: 'Domains',
                  dataIndex: 'ssoDomains',
                  key: 'ssoDomains',
                  render: (val: Array<{ domain: string }>) => (
                    <Typography.Text ellipsis style={{ maxWidth: 300, display: 'inline-block' }}>
                      {Array.isArray(val) ? val.map((d) => d.domain).join(', ') : ''}
                    </Typography.Text>
                  ),
                },
                { title: 'Entity ID', dataIndex: 'entityId', key: 'entityId' },
                {
                  title: 'SSO URL',
                  dataIndex: 'signinUrl',
                  key: 'signinUrl',
                  render: (val: string) => (
                    <Typography.Text ellipsis style={{ maxWidth: 360, display: 'inline-block' }}>
                      {val}
                    </Typography.Text>
                  ),
                },

                {
                  title: 'Certificate',
                  dataIndex: 'certificate',
                  key: 'certificate',
                  render: (val: string) => (
                    <Typography.Text ellipsis style={{ maxWidth: 360, display: 'inline-block' }}>
                      {val}
                    </Typography.Text>
                  ),
                },
              ]}
              dataSource={items}
              onRow={(record) => ({
                onClick: () => history.push(route(ROUTES.SSO_CONFIG, { id: record.id })),
                style: { cursor: 'pointer' },
              })}
              rowKey={(row) => row.id}
              scroll={{ x: true }}
            />
          )}
        </StyledCard>
      </Layout>
    </SidebarLayout>
  )
}
